export default __webpack_public_path__ + "images/5fdba2b8450301347ea9966a16951f6c-comedy_tablet.webp";